/*
  Media queries config
  Usage example:
  @media ${media.tablet} {
      <properties>
   }
*/

const breakpoints: { [key: string]: number } = {
  mobile: 361,
  small: 640,
  tablet: 768,
  medium: 1168,
  large: 1536,
  xlarge: 1920,
};

export default Object.keys(breakpoints).reduce(
  (acc: { [key: string]: string }, cur: string) => {
    acc[cur] = `(min-width: ${breakpoints[cur]}px)`;
    return acc;
  },
  {},
);

export const maxWidth = Object.keys(breakpoints).reduce(
    (acc: { [key: string]: string }, cur: string) => {
        acc[cur] = `(max-width: ${breakpoints[cur]}px)`;
        return acc;
    },
    {}
);
